'use client'

import {
    COMPLETE_STATS,
    completeFixture,
} from '@/app/_components/ground/complete-fixture'
import type { GroundData } from '@/app/_components/ground/load-ground-data'
import { SpecimenFrame } from '@/app/_components/ground/specimen-frame'
import { KanjiResultGrid, ReflectionHeadline } from '@/components/practice'
import { MarginaliaTop } from '@/learn/completed/_components/marginalia-top'
import { StatsLine } from '@/learn/completed/_components/stats-line'

// Beat 05: Learn complete, the fifteen-kanji grid filling as the scroll
// advances (`revealed` = cells shown).
export function CompleteSpecimen({
    data,
    revealed,
}: {
    data: Pick<GroundData, 'lesson' | 'roster'>
    revealed: number
}) {
    const results = completeFixture(data.roster)
    return (
        <SpecimenFrame beat={5}>
            <MarginaliaTop
                lessonNumber={data.lesson.number}
                kanjiCount={COMPLETE_STATS.kanjiCount}
                firstTryRate={COMPLETE_STATS.firstTryRate}
            />
            <div className="mt-8" data-focus>
                <ReflectionHeadline
                    lessonNumber={data.lesson.number}
                    verb="Learn complete."
                />
            </div>
            <KanjiResultGrid
                results={results}
                revealed={revealed}
                ariaLabel="Lesson 1, fifteen frames"
            />
            <StatsLine {...COMPLETE_STATS} />
        </SpecimenFrame>
    )
}
